import * as IMAGES from './Images';
export const global = {
  backgroundColor: '#ffffff',
  fontFamily: 'Open Sans'
};

export const header = {
  display: 'flex',
  position: 'fixed',
  top: '0px',
  width: '100%',
  border: '0',
  boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  zIndex: '150',
  alignItems: 'center'
};

export const formInLanding = {};

export const mobileFooterFontStyle = {
  fontSize: '12px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.67',
  letterSpacing: '0.09px',
  color: 'rgba(0, 0, 0, 0.87)',
  marginBottom: '10px'
};

export const centerForRelative = {
  transform: 'translateY(-50%) translateX(-58%)',
  position: 'absolute',
  top: '50%',
  left: '50%'
};

export const footerHeadFontStyle = {
  fontSize: '14px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#ffffff'
};

export const footerHeadFontBoldStyle = {
  fontSize: '18px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#ffffff'
};

export const oyoLogoStyle = {
  marginLeft: '30px',
  height: '50px',
  width: '110px'
};

export const oyoLogoStyleMobile = {
  marginLeft: '15px',
  height: '40px',
  width: '80px'
};

export const footerGlobal = {
  backgroundColor: '#3f4148',
  height: '837px',
  padding: '0px 35px 0px 80px',
  borderBottom: 'solid #6d787d'
};

export const footerBottomMost = {
  marginTop: '7px',
  fontSize: '12px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  opacity: '0.54',
  letterSpacing: 'normal',
  color: '#ffffff'
};

export const footerHeadTop = {
  display: 'flex',
  paddingTop: '30px',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: '#ffffff'
};

export const footerHeadBottom = {
  display: 'flex',
  opacity: '0.54',
  fontFamily: 'TTInterphases',
  marginTop: '30px',
  borderBottom: '#aaa solid 0.1px',
  paddingBottom: '33px',
  fontSize: '14px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#ffffff'
};

export const vertCenter = {
  margin: '0',
  transform: 'translateY(25%)'
};

export const vertCenterText = {
  margin: '0',
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)'
};

export const headerBoldText = {
  fontFamily: 'Open Sans',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.56',
  letterSpacing: 'normal',
  color: '#222222'
};

export const headerRegularText = {
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgba(31, 31, 31, 0.87)'
};

export const joinUsBtn = {
  width: '156.4px',
  height: '44px',
  borderRadius: '4px',
  backgroundColor: '#1ab64f',
  marginRight: '20px',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  textTransform: 'uppercase'
};

export const AssetTransformation = {
  height: '40px',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.25',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgba(0, 0, 0, 0.7)',
  margin: '8px auto 0'
};

export const Group3 = {
  width: '80px',
  height: '80px',
  objectFit: 'contain'
};

export const Group3Mobile = {
  width: '24px',
  height: '24px',
  objectFit: 'contain'
};

export const AssetTransformationMobile = {
  width: '93px',
  height: '53px',
  fontSize: '12px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: 'rgba(0, 0, 0, 0.7)',
  marginTop: '28%',
  marginLeft: '4px'
};

export const KnowMore = {
  fontSize: '16px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: '-0.53px',
  color: '#1ab64f',
  cursor: 'pointer',
  marginTop: '42px',
  textAlign: 'center',
  textTransform: 'uppercase'
};

export const KnowMoreMobile = {
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: '-0.47px',
  color: '#1ab64f',
  cursor: 'pointer',
  marginTop: '29px',
  textTransform: 'uppercase'
};

export const Group8 = {
  width: '138px',
  height: '138px',
  objectFit: 'contain'
};

export const Group85 = {
  width: '132px',
  height: '146px',
  objectFit: 'contain'
};

export const FlexColumn = {
  display: 'flex',
  flexDirection: 'column'
};

export const FlexRow = {
  display: 'flex',
  flexDirection: 'row'
};

export const Step1 = {
  height: '16px',
  fontSize: '12px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  marginTop: '40px'
};

export const WhyYouShouldChoos = {
  fontSize: '24px',
  color: 'rgba(0, 0, 0, 0.54)',
  textTransform: 'uppercase'
};

export const WhyYouShouldChoosMobile = {
  fontSize: '14px',
  color: 'rgba(0, 0, 0, 0.54)',
  textTransform: 'uppercase'
};

export const scrollingWrapperFlexbox = {
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  justifyContent: 'space-between',
  overflowY: 'hidden'
};

export const card = {
  flex: '0 0 auto'
};

export const editErrorModal = {
  width: '70%',
  margin: '60px auto',
  background: 'white',
  borderRadius: '4px',
  textAlign: 'left'
};

export const editErrorModalMobile = {
  // width: '44%',
  margin: '20% auto',
  background: 'white',
  borderRadius: '4px',
  textAlign: 'left',
  width: '70%'
};

export const editErrorModal_heading = {
  float: 'left',
  fontSize: '20px',
  fontWeight: 'bold',
  marginTop: '49px',
  marginLeft: '3.75%'
};

export const editErrorModal_headingVideo = {
  fontSize: '20px',
  fontWeight: 'bold',
  borderBottom: '1px solid #ddd',
  padding: '18px 20px',
  height: '20px'
};

export const editErrorModal_headingMobile = {
  float: 'left',
  fontSize: '20px',
  fontWeight: 'bold',
  marginTop: '40px',
  marginLeft: '8.57%',
  height: '30px'
};

export const close_button = {
  float: 'right',
  cursor: 'pointer',
  color: '#1ab64f',
  height: '24px',
  width: '24px',
  marginTop: '14px',
  marginRight: '3.75%'
};

export const close_buttonMobile = {
  float: 'right',
  cursor: 'pointer',
  color: '#1ab64f',
  height: '24px',
  width: '24px',
  marginTop: '21px',
  marginRight: '5.36%'
};

export const RectangleCopy4 = {
  width: '100%',
  height: '366px',
  borderRadius: '8px',
  boxShadow: '0 3px 4px 0 rgba(157, 157, 157, 0.14)',
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  marginRight: '30px'
};

export const RectangleCopy4Mobile = {
  width: '320px',
  height: '139px',
  borderRadius: '8px',
  boxShadow: '0 3px 4px 0 rgba(157, 157, 157, 0.14)',
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  marginRight: '8px'
};

export const FinancialSupport = {
  fontSize: '16px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  color: '#231815',
  marginTop: '26px',
  textAlign: 'center',
  marginBottom: '12px'
};

export const FinancialSupportMobile = {
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  color: '#231815',
  marginTop: '16px'
};

export const FinancialSupportTo = {
  width: '184px',
  height: '53px',

  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  margin: '12px auto 0'
};

export const FinancialSupportToMobile = {
  width: '193px',
  height: '32px',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  color: 'var(-black)',
  marginTop: '12px'
};

export const imgMobile = {
  alignSelf: 'center',
  marginTop: '19px',
  marginLeft: '3.4375%',
  marginRight: '3.75%'
};

export const imgDesktop = {
  alignSelf: 'center',
  marginTop: '19px'
};

export const StepImgDesktop = {
  alignSelf: 'center',
  marginTop: '38px'
};

export const StepImgMobile = {
  alignSelf: 'center',
  marginRight: '26px'
};

export const WhyImgDesktop = {
  textAlign: 'center',
  marginTop: '33px',
  width: '164px',
  height: '94px'
};

export const WhyImgMobile = {
  alignSelf: 'center',
  marginTop: '24px'
};

export const KnowMoreContent = {
  width: '77%',
  padding: '93px 3.75% 35px',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: 'rgba(0, 0, 0, 0.54)'
};

export const KnowMoreContentMobile = {
  width: '77%',
  padding: '77px 8.57% 27px',

  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: 'rgba(0, 0, 0, 0.54)'
};

export const OYOTeamComesToMe = {
  width: '69%',
  height: '72px',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  margin: '5px auto 0'
};

export const OYOTeamComesToMeMobile = {
  width: '85%',
  height: '60px',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: 'normal',
  color: 'var(-black)'
};

export const WhyOYO = {
  width: '153px',
  marginRight: '75px',
  marginLeft: '20px'
};

export const WhyOYOMobile = {
  width: '146px',
  marginRight: '10%'
};

export const Step1Mobile = {
  height: '16px',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: 'var(-black)',
  marginBottom: '5px'
};

// export const CategoryImg = {
//   width: '586px'
// };

export const CategoryImgMobile = {
  width: '100%',
  order: '2',
  marginTop: '23px',
  marginBottom: '20px'
};

export const SubCategoryImg = {
  // width: '233px',
  marginTop: '116px',
  paddingRight: '23%'
};

export const SubCategoryImgMobile = {
  width: '144px',
  height: '81px',
  marginRight: '13px'
};

export const CategoryHeading = {
  width: '186px',
  height: '32px',
  fontSize: '26px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.23',
  letterSpacing: 'normal',
  color: '#333333'
};

export const CategoryHeadingMobile = {
  width: '99px',
  height: '32px',
  fontSize: '16px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: 'rgba(0, 0, 0, 0.87)'
};

export const SubCategoryHeadingMobile = {
  height: '23px',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  letterSpacing: 'normal',
  color: '#222222'
};

export const SubCategoryHeading = {
  // width: '250px',
  height: '23px',
  fontSize: '20px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.15',
  letterSpacing: 'normal',
  color: '#222222',
  marginTop: '26px'
};

export const CategoryContent = {
  width: '88%',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.69',
  letterSpacing: 'normal',
  color: 'rgba(0, 0, 0, 0.54)',
  marginTop: '19px'
};

export const CategoryContentMobile = {
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: 'normal',
  color: 'var(-black)'
};

export const SubCategoryContent = {
  // width: '229px',
  height: '135px',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.93',
  letterSpacing: 'normal',
  color: '#000000',
  marginTop: '15px'
};

export const SubCategoryContentMobile = {
  fontSize: '12px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: 'var(-black)',
  marginBottom: '42px'
};

export const CategoryTextRight = {
  order: '2',
  width: '46%'
  // marginLeft: '60px'
};

export const CategoryTextLeft = {
  order: '1',
  width: '46%'
  // marginRight: '60px'
};

export const CategoryImgLeft = {
  order: '1',
  width: '48%'
};

export const CategoryImgRight = {
  order: '2',
  width: '48%'
};

export const CategoryTextMobile = {
  order: '1'
};

export const SubCategory = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between'
};

export const Video = {
  width: '380px',
  height: '300px',
  borderRadius: '8px',
  boxShadow: '0 3px 4px 0 rgba(157, 157, 157, 0.14)',
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  marginRight: '15px'
};

export const VideoMobile = {
  width: '266px',
  // height: '296px',
  borderRadius: '8px',
  boxShadow: '0 3px 4px 0 rgba(157, 157, 157, 0.14)',
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  flexDirection: 'column',
  marginRight: '15px'
};

export const VideoHeader = {
  position: 'relative',
  textAlign: 'left',
  left: '16px',
  height: '16px',
  fontFamily: 'InterphaseBold',
  fontSize: '18px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '0.89',
  letterSpacing: 'normal',
  color: '#231815',
  marginTop: '16px'
};

export const VideoHeaderMobile = {
  width: '135px',
  height: '16px',
  opacity: '0.87',

  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  color: '#231815',
  marginLeft: '6.2%',
  marginTop: '16px',
  order: '2'
};

export const VideoContentMobile = {
  width: '195px',
  // height: '51px',
  opacity: '0.54',

  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: 'var(-black)',
  margin: '13px 6.5% 16px 6.2%',
  order: '3'
};

export const VideoContent = {
  position: 'relative',
  left: '16px',
  textAlign: 'left',
  height: '48px',
  opacity: '0.54',

  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000',
  margin: '13px 6.5% 0 0%'
};

export const PlayVideo = {
  width: '103px',
  height: '20px',
  borderRadius: '2px',
  backgroundColor: '#000000',
  color: 'white',
  fontSize: '14px',
  fontWeight: 'bold',
  marginLeft: '3.2%',
  textAlign: 'center',
  opacity: '0.84',
  marginTop: '-12px',
  cursor: 'pointer',
  textTransform: 'uppercase'
};

export const PlayVideoMobile = {
  width: '84px',
  height: '19px',
  borderRadius: '2px',
  backgroundColor: 'black',
  color: 'white',
  fontSize: '11px',
  fontWeight: 'bold',
  marginLeft: '3.2%',
  textAlign: 'center',
  opacity: '0.84',
  cursor: 'pointer',
  order: '4',
  paddingTop: '5px',
  marginTop: '-15px',
  textTransform: 'uppercase'
};

export const GETSTARTED1btnbg = {
  width: '202px',
  height: '46px'
};

export const Form_Step3_Web = {
  width: '100%',
  height: '830px',
  backgroundColor: '#ffffff',
  overflow: 'hidden',
  zIndex: '1',
  // position: "absolute",
  position: 'relative',
  top: '0px',
  left: '0px'
};

export const thanksTick = {
  paddingTop: '198px',
  textAlign: 'center'
};

export const thanks_content = {
  fontSize: '18px',
  color: 'rgba(34, 34, 34, 0.54)',
  textAlign: 'center'
};

export const Form_input = {
  width: '74%',
  height: '46px',
  borderRadius: '2px',
  border: 'solid 1px #a6a6a6',
  backgroundColor: '#ffffff',
  marginTop: '4px',
  fontSize: '14px',
  padding: '0 3%'
};

export const Form_input_header = {
  height: '24px',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: '#222222'
};

export const StepForm = {
  fontSize: '18px',
  fontWeight: 'bold',
  color: '#333333'
};

export const StepForm2 = {
  fontSize: '16px',
  color: 'rgba(0, 0, 0, 0.54)',
  marginLeft: '0.3%'
};

export const AllCommunicationFr = {
  width: '79%',
  height: '17px',

  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#222222',
  marginTop: '13px'
};

export const AllCommunicationFrMobile = {
  width: '319px',
  height: '34px',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#222222',
  marginTop: '4px'
};

export const back_button = {
  width: '191px',
  height: '19px',
  borderRadius: '4px',
  border: 'solid 2px #1ab64f',
  fontSize: '16px',
  fontWeight: 'bold',
  color: '#1ab64f',
  textAlign: 'center',
  padding: '1.8% 0',
  cursor: 'pointer'
};

export const next_button = {
  width: '195px',
  height: '23px',
  borderRadius: '4px',
  backgroundColor: '#1ab64f',
  fontSize: '16px',
  fontWeight: 'bold',
  color: '#ffffff',
  textAlign: 'center',
  padding: '1.8% 0',
  marginLeft: '4%',
  cursor: 'pointer'
};

export const buttons = {
  display: 'flex',
  justifyContent: 'flex-end'
};

export const StepFormMobile = {
  height: '32px',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#333333',
  marginTop: '12px'
};
export const StepFormMobile2 = {
  fontSize: '12px',
  color: 'rgba(0, 0, 0, 0.54)',
  marginLeft: '0.3%'
};
export const dropdown_box = {
  width: '470px',
  height: '48px'
};
export const dropdown_options = {
  width: '94%',
  height: '20px',
  fontSize: '14px',
  padding: '15px 3%'
};
export const pullup_menu = {
  width: '90%',
  border: 'solid 1px #979797',
  backgroundColor: '#ffffff',
  padding: '0 5%'
};
export const pullup_options = {
  width: '100%',
  height: '19px',
  opacity: '0.87',
  fontSize: '18px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: 'var(-black)',
  padding: '15px 0',
  borderBottom: 'solid 1px #979797'
};
export const ready_to_get_started = {
  width: '100%',
  // backgroundColor: '#f3f5f7',
  paddingBottom: '80px',
  paddingTop: '60px'
};
export const ready_to_get_started_mobile = {
  width: '100%',
  paddingBottom: '30px'
  // backgroundColor: '#f2f3f8'
};
export const contact = {
  width: '129px',
  height: '16px',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgba(31, 31, 31, 0.87)',
  order: 1,
  padding: '16px 0'
};
export const contact_mobile = {
  width: '113px',
  height: '16px',
  fontSize: '14px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgba(31, 31, 31, 0.87)',
  order: 2,
  margin: '24px auto 0'
};
export const joinUsReady = {
  width: '100%',
  height: '44px',
  borderRadius: '4px',
  backgroundColor: '#1ab64f',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  textTransform: 'uppercase'
};

export const readyImg = {
  width: '68%',
  objectFit: 'contain',
  marginTop: '2.1%'
};

export const readyImgMobile = {
  // width: '328px',
  // height: '198px',
  objectFit: 'contain',
  marginTop: '10px'
  // margin: '56px auto 0'
};

export const ReadyToGetStarted_header_mobile = {
  height: '50px',
  opacity: '0.87',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2.25',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#231815',
  marginTop: '38px',
  fontFamily: 'InterphaseBold'
};

export const ReadyToGetStarted_header = {
  opacity: '0.87',
  fontSize: '36px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: '#000000',
  marginTop: '12.6%',
  fontFamily: 'InterphaseBold'
  // marginLeft: '12.8%'
};

export const ListingYourBusines = {
  opacity: '0.7',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000',
  width: '415px',
  height: '72px',
  marginTop: '16px',
  paddingBottom: '10px'
};

export const ListingYourBusines_mobile = {
  height: '72px',
  opacity: '0.87',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'var(-black)',
  margin: '17px 4%'
};
export const VideoThumbnail = {
  width: '380px',
  height: '172px'
};

export const VideoThumbnailMobile = {
  width: '266px',
  height: '152px',
  order: '1',
  overflow: 'hidden'
};

export const dropdown = {
  width: '100%',
  overflow: 'scroll',
  height: '150px',
  borderRadius: '4px',
  boxShadow: '0 2px 12px 2px rgba(0, 0, 0, 0.11)',
  zIndex: '2',
  position: 'absolute',
  backgroundColor: 'white'
};
export const dropdownPage1 = {
  left: '0.3%',
  width: '80%',
  overflow: 'scroll',
  height: '110px',
  borderRadius: '4px',
  boxShadow: '0 2px 12px 2px rgba(0, 0, 0, 0.11)',
  zIndex: '2',
  position: 'relative',
  backgroundColor: 'white'
};

export const pullUp_menu_header = {
  width: '100%',
  height: '24px',
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: 'rgba(34, 34, 34, 0.54)',
  marginTop: '14px'
};

export const landingOyoForm = {};
export const becomeAnOyoStyle = {};
export const inputTopTextStyle = {
  opacity: '0.54',
  fontSize: '14px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#000000'
};
export const inputStyle = {
  width: '100%',
  marginBottom: '50px',
  height: '20px'
};

export const horizontalLineStyle = {
  marginTop: '20px',
  width: '328px',
  height: '1px',
  left: '-26px',
  position: 'relative',
  backgroundColor: '#ffffff',
  opacity: '0.1'
};

export const circleStyles = {
  position: 'relative',
  width: '25px',
  height: '25px',
  backgroundColor: '#ffffff',
  borderRadius: '50%',
  border: 'solid 1px rgba(0, 0, 0, 0.1)',
  top: '-20px',
  left: '128px'
};

export const circleContentStyles = {
  fontSize: '10px',
  padding: '4px',
  position: 'relative',
  top: '-2px',
  dial_Codewidth: '14px',
  height: '13px',
  opacity: '0.54',
  fontSize: '10px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};

export const sellerStyle = {
  position: 'relative',
  top: '-14px',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#616161'
};
export const footer_social = {
  width: '224px',
  display: 'flex',
  justifyContent: 'space-between',
  opacity: '0.3'
};
export const footer_bottom_links = {
  borderTop: 'rgba(170, 170, 170, 0.08) solid 0.1px',
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: '24px'
};
export const contact_us = {
  width: '240px',
  boxShadow: '0 4px 4px 0 rgba(97, 97, 97, 0.5)',
  border: 'solid 1px rgba(151, 151, 151, 0.1)',
  backgroundColor: '#ffffff',
  position: 'absolute',
  right: '59%',
  padding: '8px 5px 14px 8px'
};
export const contact_us_options = {
  height: '16px',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  // textAlign: 'center',
  color: '#1f1f1f',
  padding: '8px 0',
  textAlign: 'left'
};
export const flag = {};

export const dialCode = {
  position: 'relative',
  left: '7px',
  top: '10px',
  fontSize: '14px',
  marginRight: '3%'
};
export const mobile_number = {
  padding: ' 0px 3% 0 13%',
  width: '64%'
};
export const form_body = {
  margin: '0 9.375%',
  display: 'flex',
  justifyContent: 'space-around'
};
export const form_body_mobile = {
  display: 'flex',
  justifyContent: 'space-around',
  flexDirection: 'column',
  margin: '0 4%'
};
export const mobile = {
  border: 'solid 1px white',
  fontSize: '15px',
  position: 'relative',
  top: '10px'
};
export const numberCheckInOyo = {
  width: '33%',
  height: '63px',
  opacity: '0.87',
  fontSize: '62px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '0.26',
  letterSpacing: 'normal',
  color: '#231815'
};
export const peopleCheckInOyo = {
  width: '66%',
  height: '48px',
  opacity: '0.87',
  fontSize: '16px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000',
  marginTop: '-13px'
};

export const booking = {
  width: '289px',
  height: '48px',
  opacity: '0.87',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: '#000000',
  borderTop: '1px solid rgba(197, 197, 197, 0.5)',
  paddingTop: '25px'
};

export const numberCheckInOyoMobile = {
  width: '110px',
  height: '57px',
  opacity: '0.87',
  fontSize: '56px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '0.29',
  letterSpacing: 'normal',
  color: '#231815'
};

export const peopleCheckInOyoMobile = {
  marginTop: '-13px',
  height: '48px',
  opacity: '0.87',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.71',
  letterSpacing: 'normal',
  color: 'var(-black)'
};
